/*
 * Copyright 2026 North Carolina State University
 */

import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Custom hook to manage facility for admin users.
 * Returns the user's facility ID to pre-select in filters.
 */
const useFacility = () => {
  const [facilityPreference, setFacilityPreference] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFacility = async () => {
      try {
        const response = await axios.get('/api/users/current');
        const userData = response.data;
        
        if (userData.institution_roles?.some(r => r.role === 'Admin') && userData.facility) {
          const prefId = userData.facility?._id || userData.facility;
          setFacilityPreference(prefId);
        }
      } catch (error) {
        console.error('Error fetching facility:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFacility();
  }, []);

  return { facilityPreference, loading };
};

export default useFacility;
